module.exports = __webpack_public_path__ + "img/ssbg8.6700944c.jpg";